var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "{20}",
    height: "{20}",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5466 13.8279C2.61604 12.2579 2.29054 10.4023 2.63121 8.60931C2.97188 6.81633 3.95529 5.20936 5.39682 4.09007C6.83835 2.97078 8.63886 2.41615 10.4603 2.5303C12.2818 2.64446 13.999 3.41954 15.2895 4.71004C16.58 6.00055 17.3551 7.71773 17.4692 9.53921C17.5834 11.3607 17.0288 13.1612 15.9095 14.6027C14.7902 16.0442 13.1832 17.0277 11.3902 17.3683C9.59726 17.709 7.74159 17.3835 6.1716 16.4529V16.4529L3.57785 17.1873C3.47158 17.2184 3.35891 17.2203 3.25164 17.1929C3.14438 17.1654 3.04647 17.1097 2.96818 17.0314C2.88989 16.9531 2.8341 16.8552 2.80666 16.7479C2.77922 16.6406 2.78114 16.528 2.81222 16.4217L3.5466 13.8279Z",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.625C10.3452 10.625 10.625 10.3452 10.625 10C10.625 9.65482 10.3452 9.375 10 9.375C9.65482 9.375 9.375 9.65482 9.375 10C9.375 10.3452 9.65482 10.625 10 10.625Z",
    fill: "#EDEDED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10.625C6.59518 10.625 6.875 10.3452 6.875 10C6.875 9.65482 6.59518 9.375 6.25 9.375C5.90482 9.375 5.625 9.65482 5.625 10C5.625 10.3452 5.90482 10.625 6.25 10.625Z",
    fill: "#EDEDED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 10.625C14.0952 10.625 14.375 10.3452 14.375 10C14.375 9.65482 14.0952 9.375 13.75 9.375C13.4048 9.375 13.125 9.65482 13.125 10C13.125 10.3452 13.4048 10.625 13.75 10.625Z",
    fill: "#EDEDED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.5352fa1b023bd18eae14d461f1bd0cca.svg";
export { ForwardRef as ReactComponent };